import React from 'react';
import styled from 'styled-components';

const Section = (props) => {
  const { children, className, wide } = props;
  return (
    <Wrapper className={className}>
      <Container wide={wide}>{children}</Container>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding: 0 20px;
  ${({ theme }) => `
    @media ${theme.mediumUp} {
      padding: 0 50px;
    }
`}
`;

const Container = styled.div`
  max-width: ${({ wide }) => (wide ? '1700px' : '1500px')};
  margin: auto;
`;

export default Section;
